import { GET_APPS, GET_FAVORITE_APPS } from '../actions/types';

import { INITIAL_STATE } from '../states/states';

export default (state = INITIAL_STATE.APPS, action) => {
  switch (action.type) {
    case GET_APPS:
      return { ...state, apps: action.payload };
    case GET_FAVORITE_APPS:
      return { ...state, favoriteApps: action.payload };
    default:
      return state;
  }
};
